var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('el-input',{attrs:{"type":"tel","placeholder":"请输入手机号","clearable":""},on:{"input":_vm.sendPhone},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }